export function roundToTwo(num: number) {
  const rounded = +(Math.round(parseFloat(num + "e+2")) + "e-2");
  if (isNaN(rounded)) return undefined;
  else return rounded;
}
